export default [
  {
    items: 1000,
    bonus: 0,
    premium: 100,
  },
  {
    items: 6000,
    bonus: 500,
    premium: 600,
  },
  {
    items: 12000,
    bonus: 2000,
    premium: 1200,
  },
  {
    items: 25000,
    bonus: 7000,
    premium: 2500,
  },
];
